var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.checklistTransactions,"item-key":"id","sort-by":"created","sort-desc":""},scopedSlots:_vm._u([{key:"item.created",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDateTime(item.created))+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"to":{ name: 'checklists-Checklist', query: { id: item.id } },"small":""}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.mdiEye)+" ")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }